import { render, staticRenderFns } from "./task-list.vue?vue&type=template&id=2d870690&scoped=true"
import script from "./task-list.vue?vue&type=script&lang=js"
export * from "./task-list.vue?vue&type=script&lang=js"
import style0 from "./task-list.vue?vue&type=style&index=0&id=2d870690&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d870690",
  null
  
)

export default component.exports